import React from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

const IncidentSeveritySelector = ({
  severity,
  onChange,
  presets,
  selectedPreset,
  label = 'Severity',
  inkColor,
  ink2Color,
  lineColor,
  surfaceColor,
}) => (
  <Box>
    <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 1, mb: 1 }}>
      <Typography sx={{ fontSize: 13, fontWeight: 700, color: inkColor }}>
        {label}
      </Typography>
      <Typography sx={{ fontSize: 12, color: ink2Color, textAlign: 'right' }}>
        <Box component="span" sx={{ color: selectedPreset.text, fontWeight: 700 }}>
          {selectedPreset.label}
        </Box>
        {' — '}
        {selectedPreset.description}
      </Typography>
    </Box>

    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
        gap: 0.75,
      }}
    >
      {presets.map((preset) => {
        const selected = severity === preset.value;
        return (
          <ButtonBase
            key={preset.key}
            onClick={() => onChange(preset.value)}
            sx={{
              borderRadius: '12px',
              px: 0.5,
              py: 1.2,
              minHeight: 64,
              border: `1.5px solid ${selected ? preset.selectedBorder : lineColor}`,
              bgcolor: selected ? alpha(preset.selectedBg, 0.2) : surfaceColor,
              color: selected ? preset.text : ink2Color,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 0.6,
              transition: 'all 180ms ease',
              transform: selected ? 'scale(1.03)' : 'scale(1)',
            }}
          >
            <Box
              sx={{
                width: 8,
                height: 8,
                borderRadius: 999,
                bgcolor: preset.dot,
              }}
            />
            <Typography sx={{ fontSize: 12, fontWeight: selected ? 700 : 600, lineHeight: 1.1 }}>
              {preset.label}
            </Typography>
          </ButtonBase>
        );
      })}
    </Box>
  </Box>
);

export default IncidentSeveritySelector;
